import { ICalendarSlot } from "../../../entities/calendar";

export const canSelectLessonCreateSlot = (slot?: ICalendarSlot): boolean => {
    return Boolean(slot?.availableActions.includes('CALENDAR_SLOT_ACTION_CREATE_EXTRA_LESSON'))
}

export const canCreateLessonInSlot = (slot?: ICalendarSlot): boolean => {
    return Boolean(slot?.isAvailableForNewLesson)
}
